import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LOGO_URL } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4 admin-scope" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white rounded-lg shadow-md border border-slate-200 p-8">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="Mobile Kitchen Company logo" className="h-16 w-auto rounded" data-testid="admin-login-logo" />
          <h1 className="mt-4 text-xl font-semibold text-slate-900">Admin Dashboard</h1>
          <p className="text-sm text-slate-500 mt-1">Mobile Kitchen Company (UK) Limited</p>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          {error && (
            <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded px-4 py-2.5" data-testid="login-error-message">
              {error}
            </div>
          )}
          <div>
            <label htmlFor="admin-email" className="block text-sm font-medium text-slate-700 mb-1.5">Email</label>
            <input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3.5 py-2.5 border border-slate-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#1A237E] focus:border-transparent"
              placeholder="admin@example.com"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="block text-sm font-medium text-slate-700 mb-1.5">Password</label>
            <input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3.5 py-2.5 border border-slate-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#1A237E] focus:border-transparent"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit-button"
            className="w-full py-2.5 bg-[#1A237E] text-white text-sm font-semibold rounded-md hover:bg-[#121A5C] transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
